import React from "react";

export default function CommerceDetailSkeleton() {
  return (
    <div className="mt-6 space-y-6">
      <div className="h-48 animate-pulse rounded-[2rem] bg-slate-200 dark:bg-slate-800" />

      <div className="grid gap-6 lg:grid-cols-[1fr_360px]">
        <div className="space-y-5">
          <div className="h-[360px] animate-pulse rounded-[2rem] bg-slate-200 dark:bg-slate-800" />
          <div className="h-40 animate-pulse rounded-3xl bg-slate-200 dark:bg-slate-800" />
          <div className="h-56 animate-pulse rounded-3xl bg-slate-200 dark:bg-slate-800" />
        </div>

        <div className="space-y-5">
          <div className="h-64 animate-pulse rounded-[2rem] bg-slate-200 dark:bg-slate-800" />
          <div className="h-32 animate-pulse rounded-3xl bg-slate-200 dark:bg-slate-800" />
          <div className="h-32 animate-pulse rounded-3xl bg-slate-200 dark:bg-slate-800" />
        </div>
      </div>
    </div>
  );
}